import { render } from "./site-detail.vue?vue&type=template&id=0538e5e8"
import script from "./site-detail.vue?vue&type=script&lang=js"
export * from "./site-detail.vue?vue&type=script&lang=js"

import "./site-detail.vue?vue&type=style&index=0&id=0538e5e8&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\Documents\\Git-Repositorios\\edge_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__